import Pagination from '@mui/material/Pagination';
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

import { Typography } from '../MuiGenerals';
import { useTranslation } from '../../hooks';

export default function CustomPagination(props: any) {
  const { t } = useTranslation('component');
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const sx = {
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px',
    },
  };

  return (
    <div style={sx.container}>
      <Typography variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {!props.noshowFooter ? (
          <>
            <span style={{}}>{t('itemTotalStart')}</span>
            <span style={{}}>{props.totalRecords}</span>
            <span style={{}}>{t('itemTotalEnd')}</span>
          </>
        ) : (
          <></>
        )}
      </Typography>
      <Pagination
        count={pageCount}
        page={page + 1}
        size="small"
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    </div>
  );
}
